interface FAQSection {
    id: number;
    header: string;
    iconName: string;
    subHeaders: {
      topic: string;
      answer: string;
    }[];
  }

export const fakeFAQData: FAQSection[] = [
  {
    id: 1,
    header: 'Account and Transactions',
    iconName: 'FaUserCircle',
    subHeaders: [
        {
          topic: 'Do I need my BVN to open wallet account?',
          answer: 'Yes as per CBN guidelines it is required to provide your BVN as a form of KYC to open a wallet account'
        },
        {
        topic: 'Can I Upgrade my account?',
        answer:
            'Yes! Upon successfully creating your account and successfully verifying your Bank Verification Number (BVN) you can continue to the next screen where you can upgrade your account to the next tier. You would be required to provide the necessary documents for upgrading your account and after confirmation your account would be successfully upgraded.',
        },
        {
        topic: 'How can i open my wallet account?',
        answer:
            'This can be done after creating an account and signing in you would be required to provide your bank verification number (BVN) to create your wallet in the swop application.',
        },
        {
        topic: 'How long does it take to open an account?',
        answer:
            'It takes less than a minute to create an account.',
        },
        {
        topic: 'How do I close my Swop account?',
        answer:
            'Navigate to the Help Center in the profile tab in the application then submit a form and our team would assist in helping you close your swop account.',
        },
        {
        topic: 'Is there a limit to the amount of money I can hold in my Swop wallet?',
        answer:
            'Yes if you have not upgraded your account upon creation you can only have a maximum balance of N300,000. Upon successfully upgrading the account the maximum would be increased to 500 thousand naira',
        },
    ],
  },
  {
    id: 2,
    header: 'Payment',
    iconName: 'FaCartPlus',
    subHeaders: [
        {
        topic: 'How do I make a payment on your platform?',
        answer:
            'After logging in navigate to the Wallet tab and choose either options of transferring to other bank accounts or another swop wallet account.',
        },
        {
        topic: 'Do you offer payment plans or installment options?',
        answer:
            'Not yet but be rest assured we are working on it.',
        },
        {
        topic: 'Are there any transaction fees?',
        answer:
            'Yes! Between swop to swop accounts for transfers below N5000 is free, N10 for transactions between N5,001 and N50,000 and N20 for transfers above N50,000. While  swop to local banks attracts N20 for bank transfers below N5,000, N42 for transfers between N5,001 and N50,000 and N50 for transactions above N50,000.',
        },
        {
        topic: 'What security measures do you have in place to protect against fraud?',
        answer:
            'We follow CBN guidelines and policies in our application to protect individuals personal details and account against cyber fraud. So be rest assured your funds are save and secured with us.',
        },
    ],
  },
  {
    id: 3,
    header: 'General',
    iconName: 'FaToolbox',
    subHeaders: [
        {
        topic: 'Can I use Swop for both personal and business transactions?',
        answer:
            'Swop is a B2C application which is required for individuals only. SPay the parent company has provisions for businesses so kindly refer to the website https://spaybusiness.com/ ',
        },
        {
        topic: 'Is Swop available in my country?',
        answer:
            'Currently swop is available in Nigeria only.',
        },
        {
        topic: 'How does the Swop referral program work?',
        answer:
            'We are currently working on making the referral program available in the application for use.',
        },
        {
        topic: 'What should I do if I suspect fraudulent activity on my Swop account?',
        answer:
            'If you notice fraudulent activities going on in your account, kindly contact our help center or send a message on our social media platforms immediately so we can investigate and take the necessary measures.',
        },
        {
          topic: 'Does Swop have a help center or knowledge base for troubleshooting common issues?',
          'answer': 'Navigate to "My Profile" then click on Swop Help Center and you would be able access our help center.'
        },
        {
          topic: 'Is Swop compatible with both iOS and Android devices?',
          answer: 'Yes. Those are the two operating systems compatible with swop'
        }
    ],
  },
];